import { __makeTemplateObject, __read, __spreadArray } from "tslib";
import { observer } from 'mobx-react';
import React, { useCallback } from 'react';
import { ItemClass, ItemUtils } from '@marvelapp/design-creator';
import styled from '@marvelapp/styled';
import theme from '@marvelapp/theme';
import { Grid } from '@marvelapp/ui';
import Layer from './Layer';
import { useLayerItemsMap, useLayerState } from './hooks';
import { isSymbolLayer } from './utils';
function LayerListItem(_a) {
    var item = _a.item, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onRename = _a.onRename, isClipped = _a.isClipped;
    var _b = useLayerState(item), isSelected = _b.isSelected, isExpanded = _b.isExpanded, setIsExpanded = _b.setIsExpanded, isHidden = _b.isHidden, filterText = _b.filterText;
    var itemsMap = useLayerItemsMap();
    var layerChildren = item.children && __spreadArray([], __read(item.children), false).reverse();
    var handleCollapse = useCallback(function (e) {
        e.stopPropagation();
        setIsExpanded(!isExpanded);
    }, [isExpanded, setIsExpanded]);
    if (isHidden) {
        return null;
    }
    var isMask = ItemUtils.getClassName(item) === ItemClass.Mask;
    var hasExpandedChildren = !isHidden && layerChildren && isExpanded;
    var shouldRenderChildren = isMask || hasExpandedChildren;
    // Children of Mask type are rendered flat, so we don't display any
    // content and just continue to render the children
    var layerContent = !isMask && (React.createElement(Layer, { filterText: filterText, isClipped: isClipped, isCollapsed: !isExpanded, isSelected: isSelected, item: item, onCollapse: handleCollapse, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onRename: onRename }));
    return (React.createElement(React.Fragment, null,
        layerContent,
        shouldRenderChildren && (React.createElement(HighlightedGrid, { gridRowGap: 1, gridTemplateColumns: "100%", paddingLeft: isMask ? 0 : 22, isSelected: isSelected, isSymbol: isSymbolLayer(item) }, layerChildren.map(function (id, idx) {
            return itemsMap[id] ? (React.createElement(LayerListItem, { isClipped: isMask && idx < layerChildren.length - 1, item: itemsMap[id], key: id, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onRename: onRename })) : null;
        })))));
}
var HighlightedGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  grid-template-columns: 100%;\n\n  ", ";\n"], ["\n  grid-template-columns: 100%;\n\n  ", ";\n"])), function (p) {
    return p.isSelected &&
        "\n      background: ".concat(theme.colors.snowDark, ";\n      border-radius: 0 0 4px 4px;\n\n      grid-template-rows: 0;\n      margin-top: -4px;\n\n      &:before {\n        content: '';\n        display: block;\n        width: calc(100% + 22px);\n        height: 4px;\n        background: ").concat(theme.colors.marvel, ";\n        transform: translate(-22px, -4px);\n      }\n    ");
});
export default observer(LayerListItem);
var templateObject_1;
